import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import MarkdownRender from 'LuxKit/MarkdownRender'
import { ICONS } from 'lib/offer/getPropertyIcon'

import type { ThingsToKnowRow } from './ThingsToKnowLayout'

function renderFinePrintContent({ type, value }: App.Property.FinePrintContent) {
  if (type === 'markdown') {
    return <MarkdownRender type="compact" fontSize="medium" content={value} />
  }

  if (type === 'text') {
    return value
  }
}

export function mapFinePrintSubsectionsToThingsToKnowRows(
  finePrintSubsections: Array<App.Property.FinePrintSubsection> | undefined,
): Array<ThingsToKnowRow> {
  return finePrintSubsections?.map((row) => {
    const Icon = ICONS[row.icon] ?? LineInfoCircleIcon

    return {
      key: row.key,
      icon: <Icon size="S" colour="neutral-one" />,
      label: row.label,
      content: renderFinePrintContent(row.content),
      collapsable: row.collapsable,
    }
  }) ?? []
}
